import { useState } from 'react';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';

export default function GeographyPage() {
  const [selectedRegion, setSelectedRegion] = useState('all');
  const [hoveredCity, setHoveredCity] = useState<string | null>(null);

  const cities = [
    { name: 'Стамбул', region: 'turkey', status: 'Главный офис', lat: 520, lng: 250, flag: '🇹🇷', phone: '+90 212 XXX XX XX', email: 'istanbul@unitycore.com' },
    { name: 'Роттердам', region: 'europe', status: 'Офис', lat: 450, lng: 230, flag: '🇳🇱', phone: '+31 10 XXX XX XX', email: 'rotterdam@unitycore.com' },
    { name: 'Белград', region: 'europe', status: 'Партнер', lat: 480, lng: 260, flag: '🇷🇸', phone: '+381 11 XXX XX XX', email: 'belgrade@unitycore.com' },
    { name: 'Подгорица', region: 'europe', status: 'Партнер', lat: 470, lng: 270, flag: '🇲🇪', phone: '+382 20 XXX XX XX', email: 'podgorica@unitycore.com' },
    { name: 'Дубай', region: 'middle-east', status: 'Офис', lat: 680, lng: 280, flag: '🇦🇪', phone: '+971 4 XXX XX XX', email: 'dubai@unitycore.com' },
    { name: 'Эр-Рияд', region: 'middle-east', status: 'Партнер', lat: 650, lng: 290, flag: '🇸🇦', phone: '+966 11 XXX XX XX', email: 'riyadh@unitycore.com' },
    { name: 'Гонконг', region: 'asia', status: 'Офис', lat: 850, lng: 260, flag: '🇭🇰', phone: '+852 XXXX XXXX', email: 'hongkong@unitycore.com' },
    { name: 'Сингапур', region: 'asia', status: 'Офис', lat: 820, lng: 270, flag: '🇸🇬', phone: '+65 XXXX XXXX', email: 'singapore@unitycore.com' },
    { name: 'Ханой', region: 'asia', status: 'Партнер', lat: 830, lng: 250, flag: '🇻🇳', phone: '+84 24 XXXX XXXX', email: 'hanoi@unitycore.com' },
    { name: 'Бангкок', region: 'asia', status: 'Партнер', lat: 810, lng: 280, flag: '🇹🇭', phone: '+66 2 XXX XXXX', email: 'bangkok@unitycore.com' },
    { name: 'Нью-Йорк', region: 'americas', status: 'Офис', lat: 200, lng: 240, flag: '🇺🇸', phone: '+1 212 XXX XXXX', email: 'newyork@unitycore.com' },
    { name: 'Майами', region: 'americas', status: 'Партнер', lat: 220, lng: 320, flag: '🇺🇸', phone: '+1 305 XXX XXXX', email: 'miami@unitycore.com' }
  ];

  const regions = [
    { id: 'all', name: 'Все', icon: 'ri-global-line' },
    { id: 'europe', name: 'Европа', icon: 'ri-map-pin-line' },
    { id: 'asia', name: 'Азия', icon: 'ri-map-pin-line' },
    { id: 'americas', name: 'Америка', icon: 'ri-map-pin-line' },
    { id: 'middle-east', name: 'Ближний Восток', icon: 'ri-map-pin-line' },
    { id: 'turkey', name: 'Турция', icon: 'ri-map-pin-line' }
  ];

  const filteredCities = selectedRegion === 'all' 
    ? cities 
    : cities.filter(city => city.region === selectedRegion);

  return (
    <div className="min-h-screen bg-white">
      <Navigation />

      {/* Hero Section */}
      <section className="pt-32 pb-20 bg-gradient-to-br from-[#0A1628] to-[#1B5E4F]">
        <div className="max-w-[1400px] mx-auto px-8 text-center">
          <h1 className="text-7xl font-bold text-white mb-6">Глобальное присутствие</h1>
          <p className="text-2xl text-[#D4AF37] font-light mb-8">
            Работаем в 12+ странах на 4 континентах
          </p>
          <div className="flex items-center justify-center gap-4 text-white/60 text-sm">
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 rounded-full bg-[#D4AF37]"></div>
              <span>Офисы</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-3 h-3 rounded-full bg-white/40"></div>
              <span>Партнеры</span>
            </div>
          </div>
        </div>
      </section>

      {/* Interactive Map Section */}
      <section className="py-20 bg-[#0A1628]">
        <div className="max-w-[1600px] mx-auto px-8">
          <div className="flex gap-8">
            {/* Map */}
            <div className="flex-1 bg-[#0F1B2E] rounded-[48px] p-12 relative">
              <svg viewBox="0 0 1200 600" className="w-full h-[600px]">
                <defs>
                  <radialGradient id="pulse">
                    <stop offset="0%" stopColor="#D4AF37" stopOpacity="0.8"/>
                    <stop offset="100%" stopColor="#D4AF37" stopOpacity="0"/>
                  </radialGradient>
                  <filter id="glow">
                    <feGaussianBlur stdDeviation="3" result="coloredBlur"/>
                    <feMerge>
                      <feMergeNode in="coloredBlur"/>
                      <feMergeNode in="SourceGraphic"/>
                    </feMerge>
                  </filter>
                </defs>
                
                {/* World map simplified paths */}
                <path d="M 150 200 Q 300 180 450 190 T 750 200 Q 900 210 1050 200" 
                      stroke="#F5F7FA" strokeWidth="1" fill="none" opacity="0.2"/>
                <path d="M 100 300 Q 250 280 400 290 T 700 300 Q 850 310 1000 300" 
                      stroke="#F5F7FA" strokeWidth="1" fill="none" opacity="0.2"/>
                <path d="M 150 400 Q 300 380 450 390 T 750 400 Q 900 410 1050 400" 
                      stroke="#F5F7FA" strokeWidth="1" fill="none" opacity="0.2"/>
                
                {/* Connection lines */}
                {filteredCities.map((city, i) => (
                  filteredCities.slice(i + 1).map((targetCity, j) => (
                    <line 
                      key={`${i}-${j}`}
                      x1={city.lng} 
                      y1={city.lat} 
                      x2={targetCity.lng} 
                      y2={targetCity.lat}
                      stroke="#D4AF37"
                      strokeWidth="0.5"
                      opacity="0.2"
                    />
                  ))
                ))}
                
                {/* Cities */}
                {filteredCities.map((city, i) => (
                  <g 
                    key={i} 
                    className="cursor-pointer transition-all"
                    onMouseEnter={() => setHoveredCity(city.name)}
                    onMouseLeave={() => setHoveredCity(null)}
                  >
                    {city.status === 'Главный офис' && (
                      <circle 
                        cx={city.lng} 
                        cy={city.lat} 
                        r="30" 
                        fill="url(#pulse)" 
                        className="animate-pulse"
                      >
                        <animate attributeName="r" from="30" to="40" dur="2s" repeatCount="indefinite"/>
                      </circle>
                    )}
                    {city.status === 'Офис' && (
                      <circle 
                        cx={city.lng} 
                        cy={city.lat} 
                        r="20" 
                        fill="url(#pulse)" 
                        className="animate-pulse"
                      >
                        <animate attributeName="r" from="20" to="30" dur="2s" repeatCount="indefinite"/>
                      </circle>
                    )}
                    <circle 
                      cx={city.lng} 
                      cy={city.lat} 
                      r={city.status === 'Главный офис' ? '12' : '8'} 
                      fill={city.status === 'Партнер' ? 'rgba(255,255,255,0.4)' : '#D4AF37'}
                      filter="url(#glow)"
                      className={hoveredCity === city.name ? 'scale-150' : ''}
                      style={{ transition: 'all 0.3s' }}
                    />
                    {hoveredCity === city.name && (
                      <g>
                        <rect 
                          x={city.lng - 80} 
                          y={city.lat - 70} 
                          width="160" 
                          height="60" 
                          rx="12" 
                          fill="rgba(255,255,255,0.95)"
                          filter="url(#glow)"
                        />
                        <text 
                          x={city.lng} 
                          y={city.lat - 45} 
                          textAnchor="middle" 
                          fill="#0A1628" 
                          fontSize="16" 
                          fontWeight="600"
                        >
                          {city.name}
                        </text>
                        <text 
                          x={city.lng} 
                          y={city.lat - 25} 
                          textAnchor="middle" 
                          fill="#666" 
                          fontSize="12"
                        >
                          {city.status}
                        </text>
                      </g>
                    )}
                  </g>
                ))}
              </svg>
            </div>

            {/* Sidebar */}
            <div className="w-[400px] flex flex-col gap-6">
              {/* Filters */}
              <div className="bg-[#0F1B2E] rounded-[32px] p-6">
                <h3 className="text-white font-semibold mb-4">Регионы</h3>
                <div className="flex flex-wrap gap-2">
                  {regions.map(region => (
                    <button
                      key={region.id}
                      onClick={() => setSelectedRegion(region.id)}
                      className={`px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                        selectedRegion === region.id
                          ? 'bg-[#D4AF37] text-[#0A1628]'
                          : 'bg-white/10 text-white hover:bg-white/20'
                      }`}
                    >
                      <i className={`${region.icon} mr-2`}></i>
                      {region.name}
                    </button>
                  ))}
                </div>
              </div>

              {/* Cities List */}
              <div className="flex-1 bg-[#0F1B2E] rounded-[32px] p-6 overflow-y-auto max-h-[500px]">
                <h3 className="text-white font-semibold mb-4">Локации ({filteredCities.length})</h3>
                <div className="space-y-3">
                  {filteredCities.map((city, i) => (
                    <div
                      key={i}
                      className="bg-white/5 hover:bg-white/10 rounded-[20px] p-4 transition-all cursor-pointer"
                      onMouseEnter={() => setHoveredCity(city.name)}
                      onMouseLeave={() => setHoveredCity(null)}
                    >
                      <div className="flex items-start justify-between mb-2">
                        <div className="flex items-center gap-3">
                          <span className="text-2xl">{city.flag}</span>
                          <div>
                            <div className="text-white font-semibold">{city.name}</div>
                            <div className="text-xs text-gray-400">{city.status}</div>
                          </div>
                        </div>
                        {city.status === 'Главный офис' && (
                          <div className="px-2 py-1 bg-[#D4AF37]/20 rounded-full">
                            <i className="ri-star-fill text-[#D4AF37] text-xs"></i>
                          </div>
                        )}
                      </div>
                      <div className="text-xs text-gray-400 space-y-1 mt-3">
                        <div className="flex items-center gap-2">
                          <i className="ri-phone-line"></i>
                          <span>{city.phone}</span>
                        </div>
                        <div className="flex items-center gap-2">
                          <i className="ri-mail-line"></i>
                          <span>{city.email}</span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-32 bg-[#F5F7FA]">
        <div className="max-w-[1400px] mx-auto px-8">
          <div className="grid grid-cols-4 gap-8">
            {[
              { value: '12+', label: 'Стран присутствия', icon: 'ri-global-line' },
              { value: '7', label: 'Собственных офисов', icon: 'ri-building-line' },
              { value: '5', label: 'Партнерских офисов', icon: 'ri-team-line' },
              { value: '24/7', label: 'Поддержка клиентов', icon: 'ri-customer-service-2-line' }
            ].map((stat, i) => (
              <div key={i} className="bg-white rounded-[40px] p-10 text-center shadow-[0_20px_60px_rgba(10,22,40,0.08)] hover:shadow-[0_30px_80px_rgba(10,22,40,0.12)] transition-all hover:-translate-y-2">
                <div className="w-16 h-16 rounded-full bg-gradient-to-br from-[#D4AF37] to-[#1B5E4F] flex items-center justify-center mx-auto mb-6">
                  <i className={`${stat.icon} text-3xl text-white`}></i>
                </div>
                <div className="text-5xl font-bold text-[#0A1628] mb-3">{stat.value}</div>
                <div className="text-gray-600 font-light">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Regional Expertise */}
      <section className="py-32 bg-white">
        <div className="max-w-[1400px] mx-auto px-8">
          <div className="text-center mb-20">
            <h2 className="text-6xl font-semibold text-[#0A1628] mb-6">Региональная экспертиза</h2>
            <p className="text-xl text-gray-600 font-light">Глубокое понимание локальных рынков</p>
          </div>

          <div className="grid grid-cols-2 gap-8">
            {[
              {
                region: 'Европа',
                countries: 'Нидерланды, Сербия, Черногория',
                expertise: ['Регистрация компаний в ЕС', 'Налоговое планирование', 'Банковские счета', 'Миграционные программы'],
                image: 'Modern European business district with contemporary architecture, Rotterdam skyline, clean urban landscape, professional corporate photography, blue sky, sophisticated atmosphere'
              },
              {
                region: 'Азия',
                countries: 'Гонконг, Сингапур, Вьетнам, Таиланд',
                expertise: ['Выход на азиатские рынки', 'Торговые операции', 'Инвестиционные структуры', 'Локальное партнерство'],
                image: 'Hong Kong and Singapore modern skyline, Asian financial centers, futuristic skyscrapers, vibrant business district, professional cityscape photography, dynamic urban environment'
              },
              {
                region: 'Ближний Восток',
                countries: 'ОАЭ, Саудовская Аравия',
                expertise: ['Бизнес в свободных зонах', 'Исламское финансирование', 'Недвижимость', 'Государственные контракты'],
                image: 'Dubai modern business district with luxury skyscrapers, Middle East financial hub, golden hour lighting, premium corporate architecture, sophisticated urban landscape'
              },
              {
                region: 'Америка',
                countries: 'США (Нью-Йорк, Майами)',
                expertise: ['Регистрация в США', 'Венчурное финансирование', 'Выход на NYSE/NASDAQ', 'M&A сделки'],
                image: 'New York Manhattan financial district skyline, Wall Street area, American business center, iconic skyscrapers, professional urban photography, corporate atmosphere'
              }
            ].map((item, i) => (
              <div key={i} className="group relative h-[400px] rounded-[48px] overflow-hidden cursor-pointer">
                <img 
                  src={`https://public.readdy.ai/ai/img_res/948a13f1eb402f8ff16472e217608fb6.jpg$%7Bitem.image%7D&width=800&height=400&seq=region${i}&orientation=landscape`}
                  alt={item.region}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent"></div>
                <div className="absolute inset-0 p-10 flex flex-col justify-end">
                  <h3 className="text-4xl font-bold text-white mb-2">{item.region}</h3>
                  <p className="text-[#D4AF37] font-light mb-6">{item.countries}</p>
                  <ul className="space-y-2">
                    {item.expertise.map((exp, j) => (
                      <li key={j} className="flex items-center gap-2 text-white text-sm font-light">
                        <i className="ri-check-line text-[#D4AF37]"></i>
                        {exp}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 bg-[#0A1628]">
        <div className="max-w-[1400px] mx-auto px-8 text-center">
          <h2 className="text-5xl font-bold text-white mb-6">Найдите ближайший офис</h2>
          <p className="text-xl text-gray-400 font-light mb-10">
            Свяжитесь с нами в любой точке мира
          </p>
          <Link to="/contacts" className="inline-flex items-center gap-3 px-12 py-5 rounded-full bg-[#D4AF37] text-[#0A1628] font-semibold text-lg whitespace-nowrap hover:shadow-2xl transition-all hover:-translate-y-1 cursor-pointer">
            Связаться с нами
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
